<template>
  <div :class="{card: true, selected:selected}">
    <div class="card-body">
      <span><h3>{{ data.name}} {{data.test ? '(Test)': ''}}</h3></span>
      <div layout="row center-left">
        <div layout="column top-left">
          <span>Start</span>
          <input type="date" class="form-control" ref="startDate" :value="convertDate(data.startDate)" @change="startDateChanged">
        </div>
        <div layout="column top-left">
          <span>Ende</span>
          <input type="date" class="form-control" ref="endDate" :value="convertDate(data.endDate)" @change="endDateChanged">
        </div>

        <!--<div :style="{color:selected ? 'orangered' : 'lightgray'}" @click="select">-->
          <!--<i class="fas fa-check-circle icon"></i>-->
        <!--</div>-->
      </div>
      <h5 style="margin-top: 0.5rem">Adresse</h5>
      <input ref="address1" type="text" :value="data.address1" class="form-control" placeholder="Adresse 1" @change="addressChanged">
      <input ref="address2" type="text" :value="data.address2" class="form-control" placeholder="Adresse 2" @change="addressChanged">
      <input ref="address3" type="text" :value="data.address3" class="form-control" placeholder="Adresse 3" @change="addressChanged">
      <h5 style="margin-top: 0.5rem">Position auf Map</h5>
      <input ref="top" type="number" :value="data.top" class="form-control" placeholder="Top" @change="posChanged">
      <input ref="left" type="number" :value="data.left" class="form-control" placeholder="Left" @change="posChanged">
    </div>
  </div>
</template>

<script>

  import moment from 'moment';

  export default {
    name: "city",
    props: ['data', 'selected'],
    methods: {
      convertDate(date) {
        return moment(date).format('YYYY-MM-DD');
      },
      select() {
        // this.$emit('onSelected', this.$props.data);
      },
      startDateChanged() {
        this.$emit('onStartDateChanged', this.$props.data, this.$refs.startDate.value);
      },
      endDateChanged() {
        this.$emit('onEndDateChanged', this.$props.data, this.$refs.endDate.value);
      },
      addressChanged() {
        this.$emit('onAddressChanged', this.$props.data, this.$refs.address1.value, this.$refs.address2.value, this.$refs.address3.value);
      },
      posChanged() {
        this.$emit('onPositionChanged', this.$props.data, this.$refs.top.value, this.$refs.left.value);
      }
    }

  }
</script>

<style scoped>

  .icon {
    font-size: 2rem;
    margin-left: 0rem;
    pointer-events: all;
    cursor: pointer;
  }

  .selected {
    border: orangered solid 3px;
    color: orangered;

  }

  input[type=date] {
    width: 12rem;
  }
  input[type=text], input[type=number] {
    margin-bottom: 0.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/cities/City.vue